export const useBookerService = () => {
	const getStartDate = () => {
		const startDate = new Date(new Date(new Date().setHours(new Date().getHours() + 3, 0)).setSeconds(0, 0))
		if (new Date().getMinutes() <= 30) {
			startDate.setMinutes(30)
		} else {
			startDate.setHours(startDate.getHours() + 1, 0, 0, 0)
		}
		return startDate
	}

	const getEndDate = () => {
		const endDate = new Date(getStartDate())
		endDate.setDate(endDate.getDate() + 3)
		endDate.setHours(12, 0, 0, 0)
		return endDate
	}

	return { getStartDate, getEndDate }
}
